import { schema, normalize } from 'normalizr';

export const entity = 'vendorReturnItem';
export const endpoints = {
  list: ({
    vendorReturnID,
    page: { size = 50, number = 1 } = {},
    sort = '',
    filter: { query = '' } = {},
  }) => ({
    url: `/admin/vendor-returns/${vendorReturnID}/items?page[size]=${size}&page[number]=${number}&sort=${sort}&filter[query]=${query}&include=Item,Reason,Taxes`,
    entity,
    list: true,
  }),
  edit: ({ vendorReturnID, itemID, payload, onSuccess }) => ({
    url: `/admin/vendor-returns/${vendorReturnID}/items/${itemID}?include=Item,Reason,Taxes`,
    payload,
    entity,
    list: false,
    onSuccess,
  }),
  delete: ({ vendorReturnID, itemID = '', payload, onSuccess }) => ({
    url: `/admin/vendor-returns/${vendorReturnID}/items/${itemID}`,
    payload,
    entity,
    list: false,
    onSuccess,
  }),
};
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'vendorReturnItemID',
  }
);
export const normalizer = result => normalize(result, entitySchema);
export const listNormalizer = result => normalize(result, [entitySchema]);
